import axios from "axios";
import {
    PlatformGridSchema,
    Platform,
    PlatformDTO,
    PlatformSchema,
    PlatformType,
    PlatformGrid,
} from "../types/Platform";
import { toSnakeCase, toCamelCase } from "../utils/objectHelper";
import qs from "qs";

export const PlatformTransport = {
    list: async (params?: object): Promise<Platform[]> => {
        const { data } = await axios.get<Platform[]>(
            `/platforms${params ? `?${qs.stringify(params)}` : ""}`
        );

        return data.map((platform) => ({
            ...platform,
            managerId: platform.manager.id,
        }));
    },
    getPlatformById: async (platformId?: number): Promise<Platform> => {
        const { data } = await axios.get<Platform[]>(`/platform/${platformId}`);

        return PlatformSchema.cast(toCamelCase(data), { stripUnknown: true });
    },

    listByProjectManager: async (id?: number): Promise<Array<Platform>> => {
        const { data } = await axios.get(id ? `/platforms/manager/${id}` : "/platform/manager", {});
        return data.map((current: any) => {
            return PlatformSchema.cast(toCamelCase(current), { stripUnknown: true });
        });
    },

    listByProjectManagerPerPlatformType: async (
        platformType?: PlatformType
    ): Promise<Array<PlatformGrid>> => {
        const { data } = await axios.get(
            platformType
                ? `/platforms/manager?platformType=${platformType}&ignoreActives=true`
                : `/platforms/manager`,
            {}
        );
        return data.map((current: any) => {
            return PlatformGridSchema.cast(toCamelCase(current), { stripUnknown: true });
        });
    },

    toggleActive: async (platform: Platform): Promise<void> => {
        const action = "toggleActive";
        await axios.patch<Platform>(`/platform/${platform.id}/actions/${action}`);
    },

    save: async (object: PlatformDTO, id: number | undefined | null): Promise<Platform> => {
        const response = await axios.request<Platform>({
            method: id ? "put" : "post",
            url: id ? `/platform/${id}` : "/platform",
            data: toSnakeCase(object),
        });

        return response.data;
    },

    formTransformer: (object: Platform): PlatformDTO => {
        return {
            name: object.name,
            type: object.type,
            managerId: object.manager.id,
            login: object.login,
            password: object.password,
            comment: object.comment,
        };
    },
};
